<div class="col">
  @for (item of breadcrumbList; track item; let i = $index) {
    <div [class.last]="i === breadcrumbList.length - 1">
      @if (i !== breadcrumbList.length - 1) {
        <div class="bc-link">
          @if (item.url) {
            <a [routerLink]="item.url.path" [queryParams]="item.url.queryParams" class="text">{{
              item.name
            }}</a>
          }
          @if (!item.url) {
            <span class="text">{{ item.name }}</span>
          }
          <i class="material-icons">navigate_next</i>
        </div>
      }
      @if (i === breadcrumbList.length - 1) {
        <span class="text">{{ item.name }}</span>
      }
    </div>
  }
</div>
